import type { ViewStateValue } from "./view-state"

export type UrlViewStateValue = string | number | boolean

export function assertUrlViewStateValue(value: ViewStateValue): asserts value is UrlViewStateValue {
  if (typeof value !== "string" && typeof value !== "number" && typeof value !== "boolean") {
    throw new Error('viewState="url" supports string, number, and boolean values only.')
  }
}

export function encodeUrlViewState(value: UrlViewStateValue) {
  return String(value)
}

export function decodeUrlViewState<T extends UrlViewStateValue>(value: string | undefined, fallback: T): T {
  if (value == null) return fallback
  if (typeof fallback === "string") return value as T
  if (typeof fallback === "number") {
    const parsed = Number(value)
    return (Number.isFinite(parsed) ? parsed : fallback) as T
  }
  if (value === "true" || value === "1") return true as T
  if (value === "false" || value === "0") return false as T
  return fallback
}

export function normalizeUrlViewStateValues(values: Readonly<Record<string, unknown>>): Record<string, string> {
  return Object.fromEntries(
    Object.entries(values).flatMap(([key, value]) => {
      if (typeof value === "string") return [[key, value] as const]
      if (typeof value === "number" || typeof value === "boolean") {
        return [[key, String(value)] as const]
      }
      return []
    })
  )
}
